import { render, staticRenderFns } from "./newEditres.vue?vue&type=template&id=530c7854&scoped=true&"
import script from "./newEditres.vue?vue&type=script&lang=js&"
export * from "./newEditres.vue?vue&type=script&lang=js&"
import style0 from "./newEditres.vue?vue&type=style&index=0&id=530c7854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c7854",
  null
  
)

export default component.exports